import { useEffect } from 'react';
import { useLocation } from '../util/router';
import analytics from '../util/analytics';

/**
 * Fires analytics.page() when the SPA route changes (replaces history.listen in analytics setup).
 * Must render under <Router>.
 */
export default function AnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    analytics.page();
  }, [location.pathname, location.search]);

  return null;
}
